// React imports
import React from "react";

// External library imports
import { Box, Typography, Slider } from "@mui/material";

interface RatingSliderProps {
  title: string;
  description: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const RatingSlider: React.FC<RatingSliderProps> = ({
  title,
  description,
  value,
  onChange,
  disabled = false
}) => {
  return (
    <Box>
      <Typography variant="body1" sx={{ fontWeight: "600", mb: 1 }}>
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ display: "block", mb: 1, lineHeight: 1.6 }}
      >
        {description}
      </Typography>
      <Box sx={{ px: 2, mt: 4, mb: 2 }}>
        <Slider
          value={value}
          onChange={(_, val) => onChange(Array.isArray(val) ? val[0] : val)}
          min={0}
          max={5}
          step={0.5}
          marks={[...Array(6)].map((_, i) => ({ value: i, label: String(i) }))}
          valueLabelDisplay="on"
          disabled={disabled}
          aria-label={title}
          aria-valuetext={`${value} out of 5`}
          sx={{
            '& .MuiSlider-valueLabel': {
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: 'primary.main',
            },
            '& .MuiSlider-mark': { 
              backgroundColor: 'grey.400' 
            },
            '& .MuiSlider-markLabel': { 
              fontSize: 12 
            },
          }}
        />
      </Box>
      <Box>
        <Typography variant="body1" sx={{ fontWeight: "600", color: "info.main", mb: 0.5 }}>
          {value.toFixed(2)}/5.00
        </Typography>
        <Typography variant="caption" sx={{ color: "info.main", fontWeight: "600" }}>
          {((value / 5) * 100).toFixed(1)}%
        </Typography>
      </Box>
    </Box>
  );
};

export default RatingSlider;

